/**
 *
 */
const calendarPickers = (function (window, $) { // eslint-disable-line no-unused-vars
	'use strict';

	var DATE_PICKER_SELECTOR = '.date-input:enabled:not([readonly]), .date-input-readonly';

     function checkLocales($inputs){
          var loadLocales = false;
          $inputs.each(function(i,el){
               var locale = $(el).attr('data-locale');
               if(!!locale){
                    loadLocales = true;
               }
          });
          return loadLocales;
     }
	/* global loadjs */
	function setupCalendarPickers ($html) {
		var $inputs = ($html ? $html.find(DATE_PICKER_SELECTOR) : $(DATE_PICKER_SELECTOR));
          var loadLocales = false;

		if ($inputs.length === 0) return;

		// @ts-ignore
		if (!loadjs.isDefined('daterangepicker')) {
			// @ts-ignore
               let ary = ['../assets/vendor/daterangepicker-jquery-upgrade-3.6/daterangepicker.js', '../assets/vendor/daterangepicker-jquery-upgrade-3.6/daterangepicker.css'];
			
               loadjs(ary, 'daterangepicker', { async: false });
		}

		// @ts-ignore
		loadjs.ready('daterangepicker', function dateRangePickerHasLoaded () {
			initCalendarPickers($html);
		});
	}

	function initCalendarPickers ($html) {
		var $inputs = ($html ? $html.find(DATE_PICKER_SELECTOR) : $(DATE_PICKER_SELECTOR));

		$inputs.each(initCalendarInput);
	}
     function initCalendarInput(i, el, singleInput = false){
          var $dateInput = $(el);
          var format = $dateInput.attr('data-format');
          var locale = $dateInput.attr('data-locale');
          var name = $dateInput.attr('name');
          singleInput = name.startsWith("val_") ? true : singleInput;
          var defaultFormat = 'YYYY-MM-DD';
          var $beginRangeInput, $endRangeInput;
          var isRange = $dateInput.hasClass('date-range-input');
          var isTime = $dateInput.hasClass('date-time-input');
          var isTimeOnly = $dateInput.hasClass('time-input');
          var is24HourFormat = isTime || isTimeOnly && format.includes("HH");
          var showDropdowns = getShowDropdowns($dateInput.attr('data-show-dropdown'));
          var minDays = $dateInput.attr('data-mindate');
          var maxDays = $dateInput.attr('data-maxdate');
          var rangeProps = {};
          var rangeHasStart = false, rangeHasEnd = false;

          if(isRange && singleInput == false){
               if($dateInput.attr('id').indexOf('S0') == 0) return;

               $beginRangeInput = $dateInput.parent().find('.date-range-input').first();
               $endRangeInput = $dateInput.parent().find('.date-range-input').last();
               $dateInput = jQuery('<input class="form-control" type="text"/>');
               $beginRangeInput.before($dateInput);

               var val = $beginRangeInput.val();
               var momentDate =  moment(val,format);
               if(val != ''){
                    rangeProps.startDate = momentDate;
                    rangeHasStart = true;
               }

               val = $endRangeInput.val();
               var momentDateEnd =  moment(val,format);
               if(val != ''){
                    rangeProps.endDate = momentDateEnd;
                    rangeHasEnd = true;
               }
               rangeProps.autoUpdateInput = rangeHasEnd && rangeHasStart;
               //$beginRangeInput.hide();
               //$endRangeInput.hide();
          }
			if(singleInput && isRange){
                    $dateInput.addClass('date-range-input-show');
               }
			
			
			var ranges = getRanges(isRange);
			var options;
			var start;
			var end;
			var datePicker;

			if (!format) format = defaultFormat;
			options = {
                    autoUpdateInput: false,
                    autoApply:true,
                    showCustomRangeLabel:false,
                    showDropdowns:showDropdowns,
                    timePicker:isTime || isTimeOnly,
                    timePicker24Hour:is24HourFormat,
                    alwaysShowCalendars: true,
                    singleDatePicker: !isRange,
                    locale: {
                         cancelLabel: 'Clear',
                         format: format
                    }
            };
           
            if(!!locale){
               moment.locale(locale);
               options.locale = {
                    cancelLabel: 'Clear',
                    format: format,
                    monthNames: moment.months(),
                    daysOfWeek: moment.weekdaysShort()
               }
            }
            if(!singleInput) Object.assign(options, rangeProps);
            
            if(isRange) options.ranges = ranges;

			if (minDays) {
				minDays = minDays.indexOf('-') >= 0 ? minDays.substring(1) : minDays;
				// @ts-ignore
				start = moment().subtract(minDays, 'days');
				// @ts-ignore
				options.minDate = start;
			}

			if (maxDays) {
				maxDays = maxDays.indexOf('+') >= 0 ? maxDays.substring(1) : maxDays;
				// @ts-ignore
				end = moment().add(maxDays, 'days');
				// @ts-ignore
				options.maxDate = end;
			}
             
			// @ts-ignore
			datePicker = $dateInput.daterangepicker(options);

			datePicker.on('apply.daterangepicker', function (ev, picker) {
                    var startDateLoc = picker.startDate;
				if (isRange) {
                         var endDateLoc = picker.endDate;
                         if(!!locale){
                              startDateLoc = startDateLoc.locale(locale);
                              endDateLoc = endDateLoc.locale(locale);
                         }
					$(this).val(startDateLoc.format(format) + (singleInput ? ' ' : ' - ') + endDateLoc.format(format));
                         if(!singleInput) $beginRangeInput.val(startDateLoc.format(format)).trigger('blur').trigger('change');
                         if(!singleInput) $endRangeInput.val(endDateLoc.format(format)).trigger('blur').trigger('change');
					return;
				}
                    if(!!locale){
                         startDateLoc = startDateLoc.locale(locale);
                    }
				$(this).val(startDateLoc.format(format));
                    $(this).trigger('change');
                    $(this).trigger('blur');
			});
               datePicker.on('show.daterangepicker', function (ev, picker) {
				if (isTimeOnly) {
					picker.container.find(".calendar-table").hide();
				}
			});
            jQuery(this).attr('autocomplete','off');
			datePicker.on('cancel.daterangepicker', function (ev, picker) {
				$(this).val('');
			});
     }
	function getShowDropdowns (showDropdowns) {
		if (showDropdowns == 'true') return true;

		return false;
	}

	/* globals moment */
	function getRanges (isRange) {
		if (!isRange) return {};

		return {
			// @ts-ignore
			'Today': [moment(), moment()],
			// @ts-ignore
			'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
			// @ts-ignore
			'Last 7 Days': [moment().subtract(6, 'days'), moment()],
			// @ts-ignore
			'Last 30 Days': [moment().subtract(29, 'days'), moment()],
			// @ts-ignore
			'This Month': [moment().startOf('month'), moment().endOf('month')],
			// @ts-ignore
			'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
		};
	}

	return {
		setupCalendarPickers: setupCalendarPickers,
          initCalendarInput:initCalendarInput
	};
}(window, jQuery));
